<template>
  <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_12554_92760)">
      <rect width="19" height="12" fill="#E9E9E9"/>
    </g>
    <defs>
      <clipPath id="clip0_12554_92760">
        <rect width="19" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'FlagRU',
}
</script>
